import { RESIDENT_LIST_LOCKED_COLUMN_IDS } from '../constants/listColumns'
import type {
  ResidentListColumnId,
  ResidentListLockedColumnId,
} from '../types/listColumns'

export {
  RESIDENT_LIST_COLUMN_OPTIONS,
  RESIDENT_LIST_CUSTOMIZABLE_COLUMN_OPTIONS,
  RESIDENT_LIST_LOCKED_COLUMN_IDS,
  RESIDENT_LIST_DATA_COLUMN_IDS,
  RESIDENT_COLUMN_VISIBILITY_STORAGE_KEY,
} from '../constants/listColumns'

export type {
  ResidentListColumnId,
  ResidentListLockedColumnId,
  ResidentColumnSettings,
} from '../types/listColumns'

export function isResidentListLockedColumn(
  columnId: ResidentListColumnId,
): columnId is ResidentListLockedColumnId {
  return RESIDENT_LIST_LOCKED_COLUMN_IDS.includes(
    columnId as ResidentListLockedColumnId,
  )
}

/** Ensure locked columns are always present (locked ids first). */
export function withLockedResidentListColumns(
  columnIds: ResidentListColumnId[],
): ResidentListColumnId[] {
  const withoutLocked = columnIds.filter(
    (columnId) => !isResidentListLockedColumn(columnId),
  )
  return [...RESIDENT_LIST_LOCKED_COLUMN_IDS, ...withoutLocked]
}

/** Map a visible column id to the API `orderBy` field used for sorting. */
export function residentListSortFieldForColumn(
  columnId: ResidentListColumnId,
): string | null {
  switch (columnId) {
    case 'vintage':
      return 'contract_start_date'
    case 'access_confirmation':
    case 'select':
      return null
    default:
      return columnId
  }
}
